<owl-carousel-o
  id="cities"
  class="cities-carousel h-52 md:h-[400px] lg:h-[600px]"
  [options]="customOptions"
>
  <ng-template id="firstSlideID" carouselSlide>
    <app-hero-section>
      @if (isDarkMode) {
        <picture class="h-full">
          <source
            media="(min-width: 1024px)"
            srcset="
              https://storage.googleapis.com/weayr-assets-non-prod/images/cities/ayr_cities_1900_extralargescreen_darkmode@1x.avif 1920w,
              https://storage.googleapis.com/weayr-assets-non-prod/images/cities/ayr_cities_1900_extralargescreen_darkmode@1x.webp 1920w,
              https://storage.googleapis.com/weayr-assets-non-prod/images/cities/ayr_cities_1600_extralargescreen_darkmode@1x.avif 1440w,
              https://storage.googleapis.com/weayr-assets-non-prod/images/cities/ayr_cities_1600_extralargescreen_darkmode@1x.webp 1440w,
              https://storage.googleapis.com/weayr-assets-non-prod/images/cities/ayr_cities_1200_largescreen_darkmode@1x.avif      1024w,
              https://storage.googleapis.com/weayr-assets-non-prod/images/cities/ayr_cities_1200_largescreen_darkmode@1x.webp      1024w,
              https://storage.googleapis.com/weayr-assets-non-prod/images/cities/ayr_cities_768_smallscreen_darkmode@1x.avif        640w,
              https://storage.googleapis.com/weayr-assets-non-prod/images/cities/ayr_cities_768_smallscreen_darkmode@1x.webp        640w
            "
            sizes="(max-width: 640px) 640px,
                               (max-width: 1024px) 1024px,
                               (max-width: 1440px) 1440px,
                               1920px"
            type="image/avif"
          />
          <img
            class="h-full w-full object-cover"
            src="https://storage.googleapis.com/weayr-assets-non-prod/images/cities/ayr_cities_1200_largescreen_darkmode@1x.webp"
            alt="ayr_cities"
            fetchpriority="high"
          />
        </picture>
      } @else {
        <picture class="h-full">
          <source
            media="(min-width: 1024px)"
            srcset="
              https://storage.googleapis.com/weayr-assets-non-prod/images/cities/ayr_cities_1900_extralargescreen_lightmode@1x.avif 1920w,
              https://storage.googleapis.com/weayr-assets-non-prod/images/cities/ayr_cities_1900_extralargescreen_lightmode@1x.webp 1920w,
              https://storage.googleapis.com/weayr-assets-non-prod/images/cities/ayr_cities_1600_extralargescreen_lightmode@1x.avif 1440w,
              https://storage.googleapis.com/weayr-assets-non-prod/images/cities/ayr_cities_1600_extralargescreen_lightmode@1x.webp 1440w,
              https://storage.googleapis.com/weayr-assets-non-prod/images/cities/ayr_cities_1200_largescreen_lightmode@1x.avif      1024w,
              https://storage.googleapis.com/weayr-assets-non-prod/images/cities/ayr_cities_1200_largescreen_lightmode@1x.webp      1024w,
              https://storage.googleapis.com/weayr-assets-non-prod/images/cities/ayr_cities_768_smallscreen_lightmode@1x.avif        640w,
              https://storage.googleapis.com/weayr-assets-non-prod/images/cities/ayr_cities_768_smallscreen_lightmode@1x.webp        640w
            "
            sizes="(max-width: 640px) 640px,
                                   (max-width: 1024px) 1024px,
                                   (max-width: 1440px) 1440px,
                                   1920px"
            type="image/avif"
          />
          <img
            class="h-full w-full object-cover"
            src="https://storage.googleapis.com/weayr-assets-non-prod/images/cities/ayr_cities_1200_largescreen_lightmode@1x.webp"
            alt="ayr_cities"
            fetchpriority="high"
          />
        </picture>
      }
    </app-hero-section>
  </ng-template>
  <!-- <ng-template id="secondSlideID" carouselSlide>
  <app-qsp-summit-section></app-qsp-summit-section>
</ng-template> -->
</owl-carousel-o>

<app-choose-zero [chooseZero]="chooseZero">
  <ng-template #chooseZero>
    <p class="lg:text-21 mt-11 text-center">
      {{ "cities.your-city.air-quality.first" | translate }}
    </p>
    <p class="lg:text-21 mt-8 text-center">
      {{ "cities.your-city.our-mission.first" | translate }}
      <span class="block">
        {{ "cities.your-city.our-mission.second" | translate }}
      </span>
    </p>
    <p class="lg:text-21 mt-8 text-center">
      {{ "cities.your-city.connecting-cities.first" | translate }}
      {{ "cities.your-city.connecting-cities.second" | translate }}
      <b>{{ "cities.your-city.connecting-cities.third" | translate }}</b>
    </p>
  </ng-template>
</app-choose-zero>
<app-how-ayr-works />
<app-avoided-emissions />
<app-sustainability-platform [list]="list" />
<app-ayr-reviews [ayrComments]="comments" />
<app-revitalized-competitive-cities />
<app-ayr-in-my />
